import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {RequestTransferModel} from "../interface/requestTransferModel";
import {RequestTransferResponse} from "../interface/requestTransferResponse";

@Injectable({
  providedIn: 'root'
})
export class InternalTransferService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  saveRequest(requestTransferModel: RequestTransferModel): Observable<RequestTransferResponse> {
    return this.http.post<RequestTransferResponse>(`${this.apiUrl}/internalTransfer/request`, requestTransferModel);
  }
}

